<template>
  <div class="timer" v-if="!isFree">
    <el-tag style="font-size:20px;font-weight: bolder" v-if="studyStatus !== 'Y'">剩余学习时间 : {{timeCountStr}}</el-tag>
    <el-tag style="font-size:20px;font-weight: bolder" v-if="studyStatus === 'Y'">您已经完成本小学的学习啦！</el-tag>
  </div>
</template>

<script>
  export default {
    name: "DocumentTimer",
    props: {
      timeCount:Number,
      studyStatus:String,
      isFree: Boolean
    },
    data() {
      return {
        timeCountSelf: this.timeCount,
        timeCountStr: 0,
        timer: '',
      }
    },
    methods: {
      /**
       * 设置倒计时
       */
      setTimeCount() {
        this.timeCountStr =  Tool.formatSeconds(this.timeCountSelf--);
        this.timer = setInterval(() => {
          if (this.timeCountSelf < 0) {
            this.completeStudy();
            clearInterval(this.timer);
            return;
          }
          this.timeCountStr =  Tool.formatSeconds(this.timeCountSelf--);
        }, 1000);
      },
      async completeStudy() {
        this.$emit("completeStudy");
      }
    },
    mounted() {

    },
    watch: {
      timeCount(newVal) {
        // 当文章付费时
        // if (!this.isFree) {
        //   this.timeCountSelf = newVal;
        //   // 调用计时器
        //   this.setTimeCount();
        // }
        this.timeCountSelf = newVal;
        this.setTimeCount();
      }
    }
  }
</script>

<style scoped>
  .timer {
    position: fixed;
    top: 120px;
    right: 110px;
  }

</style>
